
import { useConfigStore } from "@/store/config";
import { defineComponent, toRefs, computed } from "vue";

export default defineComponent({
  props: {
    plan: {
      type: Object,
      required: true,
    },
    coupon: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const config = useConfigStore();
    let { plan, coupon } = toRefs(props);
    const plansMap = config.plansMap;

    const planSelected = computed(() => {
      return plansMap.get(plan.value!.code);
    });

    const annualDiscount = computed(() => {
      if (planSelected?.value?.code === "otcpro_annual") {
        let otcpro = plansMap.get("otcpro");
        if (!otcpro) {
          return 0;
        }
        return otcpro.unitAmount * 2;
      }
      return 0;
    });

    const annualDiscountFormatted = computed(() => {
      return annualDiscount.value !== 0 ? `-$${(annualDiscount.value / 100).toFixed(2)}` : null;
    });

    const planCost = computed(() => {
      if (planSelected?.value?.code === "otcpro_annual") {
        return planSelected.value.unitAmount + annualDiscount.value;
      }
      return planSelected?.value?.unitAmount ? planSelected.value.unitAmount : 0;
    });

    const couponDiscount = computed(() => {
      let planPrice = planSelected?.value?.unitAmount;
      if (!planPrice) {
        return 0;
      }
      if (coupon.value.code == null || coupon.value.discount == null) {
        return 0;
      }
      let discountValue = coupon.value.discount.value;
      switch (coupon.value.discount.type) {
        case "percent":
          return planPrice * (discountValue / 100);
        case "fixed":
          return discountValue < planPrice ? discountValue : planPrice;
        default:
          return 0;
      }
    });

    const couponDiscountFormatted = computed(() => {
      return `-$${(couponDiscount.value / 100).toFixed(2)}`;
    });

    const planCostFormatted = computed(() => {
      return `$${(planCost.value / 100).toFixed(2)}`;
    });

    const totalCost = computed(() => {
      return planCost.value - annualDiscount.value - couponDiscount.value;
    });

    const totalCostFormatted = computed(() => {
      return `$${(totalCost.value / 100).toFixed(2)}`;
    });

    return {
      planCostFormatted,
      totalCostFormatted,
      annualDiscountFormatted,
      couponDiscountFormatted,
      planSelected,
    };
  },
});
